import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import SplashCursor from './SplashCursor';
import { FaWhatsapp, FaTelegramPlane, FaInstagram, FaFacebookF, FaYoutube } from 'react-icons/fa';
import './Terms.css'; // Reusing the premium styles
import './MainPage.css'; 
import Footer from './Footer';

const Disclaimer = () => {
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <div className="terms-page">
      <SplashCursor RAINBOW_MODE={false} COLOR="#A855F7" />

      {/* Navigation */}
      <header className="header">
        <div className="header-container">
          <div className="logo" onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>
            <img src="/images/Final Font Stocks4U1.png" alt="Stocks4U Logo" className="logo-text" style={{ width: '150px', height: 'auto' }} />
          </div>
          
          <nav className={`nav ${isMobileMenuOpen ? 'nav-open' : ''}`}>
            <a href="/" onClick={() => setIsMobileMenuOpen(false)}>Home</a>
            <a href="/#features" onClick={() => setIsMobileMenuOpen(false)}>Features</a>
            <a href="/#pricing" onClick={() => setIsMobileMenuOpen(false)}>Pricing</a>
            <a href="/about" onClick={() => setIsMobileMenuOpen(false)}>About</a>
            <a href="/#contact" onClick={() => setIsMobileMenuOpen(false)}>Contact</a>
          </nav>

          <button
            className={`mobile-menu-toggle ${isMobileMenuOpen ? 'active' : ''}`}
            onClick={toggleMobileMenu}
            aria-label="Toggle navigation menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
          
          <div className="header-buttons">
            <button className="login-btn" onClick={() => navigate('/login')}>Login</button>
            <button className="get-started-btn" onClick={() => navigate('/login')}>Get Started</button>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="terms-hero-new">
        <div className="terms-hero-bg-glow"></div>
        <div className="terms-hero-content">
          <motion.h1 
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="terms-title-hero"
          >
            <span className="gradient-text-hero">Disclaimer</span>
          </motion.h1>
          <motion.p 
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="terms-hero-desc"
          >
            Important legal information and limitations of liability.
          </motion.p>
        </div>
      </section>

      {/* Content Section */}
      <section className="terms-content-section">
        <div className="container terms-container">
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="terms-glass-card"
          >
            <div className="terms-header-info">
              <p><strong>Effective Date:</strong> <span className="highlight">[Effective Date]</span></p>
              <p><strong>Website/App Name:</strong> Stocks4U</p>
              <p><strong>Owned & Operated By:</strong> <span className="highlight">[Your Company Name]</span></p>
              <p><strong>Contact Email:</strong> <span className="highlight">[Your Email]</span></p>
            </div>

            <p className="terms-intro">
              This Disclaimer applies to the use of Stocks4U, including our website, dashboard, tools, screeners, filters, charts, alerts, data views, APIs, software, content, and related services.
              <br/><br/>
              By using Stocks4U, you acknowledge and agree to this Disclaimer.
            </p>

            <div className="terms-body">
              <section className="terms-point">
                <h2>1. GENERAL INFORMATION</h2>
                <p>Stocks4U is a technology-based stock market data filtering and analysis platform.</p>
                <p>Stocks4U helps users view, organize, filter, scan, and analyze market-related data through tools, screeners, indicators, dashboards, charts, alerts, and system-generated outputs.</p>
                <p>Stocks4U is not a stock broker, investment adviser, research analyst, portfolio manager, exchange, depository participant, mutual fund distributor, or any other regulated securities market intermediary.</p>
                <p>Stocks4U is a third-party API/data-dependent technology platform. The platform may depend on third-party APIs, data vendors, brokers, exchanges, public sources, cloud services, payment gateways, and other external service providers.</p>
              </section>

              <section className="terms-point">
                <h2>2. NO INVESTMENT ADVICE</h2>
                <p>Stocks4U does not provide investment advice, financial advice, trading advice, stock tips, buy/sell recommendations, research reports, portfolio advice, wealth management, or guaranteed profit strategies.</p>
                <p>All information available on Stocks4U is provided only for educational, informational, analytical, and technology-support purposes.</p>
                <p>Any stock name, symbol, chart, filter, alert, signal, scanner, score, watchlist, indicator, setup, or data point displayed on Stocks4U should not be considered as a recommendation to buy, sell, hold, enter, exit, or trade any security or financial instrument.</p>
                <p>Users must make their own independent trading and investment decisions.</p>
              </section>

              <section className="terms-point">
                <h2>3. SEBI REGISTRATION DISCLAIMER</h2>
                <p>Stocks4U, its owners, directors, employees, developers, partners, affiliates, representatives, and associates are not registered with SEBI as an Investment Adviser, Research Analyst, Stock Broker, Portfolio Manager, or any other regulated market intermediary, unless specifically stated in writing.</p>
                <p>Stocks4U does not claim to be a SEBI-registered investment advisory service or research analyst platform.</p>
                <p>Stocks4U does not provide personalized investment advice, personalized trading advice, research recommendations, or portfolio-specific guidance.</p>
                <p>Users should consult a SEBI-registered investment adviser, research analyst, financial advisor, or qualified professional before making any investment or trading decision.</p>
              </section>

              <section className="terms-point">
                <h2>4. THIRD-PARTY API AND DATA DEPENDENCY</h2>
                <p>Stocks4U may receive, process, calculate, display, or organize data from third-party APIs, market data providers, brokers, exchanges, vendors, public websites, or external systems.</p>
                <p>Stocks4U does not own, control, or guarantee the accuracy, availability, completeness, reliability, legality, speed, or continuity of any third-party data or API.</p>
                <p>Market data shown on Stocks4U may be delayed, incomplete, incorrect, unavailable, mismatched, interrupted, or affected by technical errors.</p>
                <p>Stocks4U shall not be responsible for any loss, damage, wrong decision, missed opportunity, trading loss, or financial consequence caused by:</p>
                <ul>
                  <li>Third-party API failure</li>
                  <li>Data delay</li>
                  <li>Incorrect or missing data</li>
                  <li>Server downtime</li>
                  <li>Internet issue</li>
                  <li>Exchange issue</li>
                  <li>Broker issue</li>
                  <li>Vendor issue</li>
                  <li>Calculation error</li>
                  <li>Software bug</li>
                  <li>System interruption</li>
                  <li>Technical failure</li>
                </ul>
                <p>Users must verify all market data independently from their broker, official exchange source, trading terminal, or other reliable source before taking any trading or investment decision.</p>
              </section>

              <section className="terms-point">
                <h2>5. MARKET RISK DISCLAIMER</h2>
                <p>Trading and investing in stocks, futures, options, commodities, currencies, and other financial instruments involves high risk.</p>
                <p>F&O trading, options trading, intraday trading, and leverage-based trading can result in substantial financial losses.</p>
                <p>Market movement is uncertain and may be affected by volatility, liquidity, news, global events, economic conditions, technical factors, regulations, and unexpected risks.</p>
                <p>Past performance, historical data, backtesting, chart patterns, technical indicators, screeners, filters, alerts, or previous results do not guarantee future performance.</p>
                <p>Stocks4U does not guarantee profit, return, accuracy, win rate, success rate, or any financial benefit.</p>
              </section>

              <section className="terms-point">
                <h2>6. ALERTS, SIGNALS AND SCREENERS</h2>
                <p>Stocks4U may provide alerts, signals, filters, screeners, scanners, dashboards, watchlists, technical indicators, or system-generated outputs based on predefined conditions, formulas, market data, or user-selected criteria.</p>
                <p>These alerts and outputs are not personal recommendations.</p>
                <p>They are generated by software logic and data processing.</p>
                <p>Users should not enter, exit, buy, sell, hold, or trade only because of any alert, signal, scanner, or notification displayed on Stocks4U.</p>
                <p>Stocks4U does not guarantee that alerts or signals will be timely, accurate, profitable, uninterrupted, or suitable for any user.</p>
              </section>

              <section className="terms-point">
                <h2>7. NO BROKERAGE OR ORDER EXECUTION</h2>
                <p>Stocks4U does not execute trades, place orders, hold user funds, manage securities, provide margin, open demat accounts, or act as a broker.</p>
                <p>If Stocks4U integrates with any broker API, trading API, or third-party service in the future, such integration will only be a technology interface and will remain subject to applicable laws, broker terms, API provider terms, and user authorization.</p>
                <p>Stocks4U shall not be responsible for failed orders, delayed orders, rejected orders, slippage, wrong order placement, broker downtime, exchange downtime, API errors, or losses caused by third-party trading systems.</p>
              </section>

              <section className="terms-point">
                <h2>8. DATA ACCURACY DISCLAIMER</h2>
                <p>Stocks4U tries to provide useful and reliable information, but we do not guarantee that any data, calculation, alert, signal, chart, scanner, filter, indicator, or output will be accurate, complete, updated, real-time, uninterrupted, or error-free.</p>
                <p>Market data may differ across brokers, exchanges, APIs, data vendors, and platforms.</p>
                <p>Users should not rely solely on Stocks4U for financial decisions.</p>
                <p>All data should be independently verified before use.</p>
              </section>

              <section className="terms-point">
                <h2>9. NO OFFICIAL AFFILIATION</h2>
                <p>Unless clearly stated in writing, Stocks4U is not officially affiliated with SEBI, NSE, BSE, MCX, NSDL, CDSL, any broker, exchange, regulator, index provider, or data provider.</p>
                <p>All third-party names, stock symbols, company names, exchange names, logos, trademarks, and references belong to their respective owners.</p>
                <p>Any reference to stocks, indices, brokers, exchanges, or third-party services is made only for identification, display, integration, or informational purposes.</p>
              </section>

              <section className="terms-point">
                <h2>10. DATA LICENSING AND USAGE</h2>
                <p>Market data may be subject to exchange rules, data vendor terms, API provider terms, broker terms, licensing restrictions, and applicable laws.</p>
                <p>Stocks4U does not grant users any ownership rights over exchange data, third-party data, API data, vendor data, or market data.</p>
                <p>Users are not allowed to copy, scrape, download, redistribute, resell, republish, commercially exploit, or misuse any data available on Stocks4U without written permission and required third-party approvals.</p>
                <p>If any exchange, data provider, API provider, broker, or authority restricts, modifies, or stops data access, Stocks4U may change, suspend, limit, or remove related features without prior notice.</p>
              </section>

              <section className="terms-point">
                <h2>11. USER RESPONSIBILITY</h2>
                <p>By using Stocks4U, you confirm that:</p>
                <ul>
                  <li>You understand the risks of trading and investing.</li>
                  <li>You are using Stocks4U only as a technology and analysis-support tool.</li>
                  <li>You will not treat any data, alert, signal, filter, scanner, or output as guaranteed advice.</li>
                  <li>You will verify all data independently before making decisions.</li>
                  <li>You will make all trading and investment decisions at your own risk.</li>
                  <li>You will not hold Stocks4U responsible for any financial loss or trading outcome.</li>
                  <li>You will comply with applicable laws, broker terms, exchange rules, API terms, and platform policies.</li>
                </ul>
              </section>

              <section className="terms-point">
                <h2>12. LIMITATION OF LIABILITY</h2>
                <p>To the maximum extent permitted by law, Stocks4U, its owners, directors, employees, developers, partners, affiliates, representatives, and associates shall not be liable for any direct, indirect, incidental, special, consequential, financial, business, trading, investment, or opportunity loss arising from:</p>
                <ul>
                  <li>Use of the platform</li>
                  <li>Inability to use the platform</li>
                  <li>Incorrect data</li>
                  <li>Delayed data</li>
                  <li>Missing data</li>
                  <li>API failure</li>
                  <li>Third-party service issue</li>
                  <li>Wrong alerts or signals</li>
                  <li>Software bug</li>
                  <li>Calculation error</li>
                  <li>Technical downtime</li>
                  <li>Market volatility</li>
                  <li>Trading or investment decision</li>
                  <li>Broker or exchange issue</li>
                  <li>User misunderstanding</li>
                  <li>Unauthorized account access</li>
                </ul>
                <p>Your use of Stocks4U is entirely at your own risk.</p>
              </section>

              <section className="terms-point">
                <h2>13. EDUCATIONAL AND INFORMATIONAL PURPOSE ONLY</h2>
                <p>All content, tools, data, charts, filters, screeners, alerts, examples, screenshots, demonstrations, and case studies available on Stocks4U are for educational, informational, analytical, and technology-support purposes only.</p>
                <p>Nothing on Stocks4U should be interpreted as financial advice, legal advice, tax advice, investment advice, trading advice, or a guarantee of results.</p>
              </section>

              <section className="terms-point">
                <h2>14. FINAL DISCLAIMER</h2>
                <p>Stocks4U is a third-party API/data-dependent technology platform for stock market data filtering and analysis.</p>
                <p>Stocks4U is not an investment adviser, research analyst, stock broker, portfolio manager, exchange, or official market data provider unless specifically stated in writing.</p>
                <p>Stocks4U does not provide tips, calls, recommendations, guaranteed profits, portfolio advice, or personalized financial guidance.</p>
                <p>All users are fully responsible for their own research, decisions, trades, investments, capital allocation, risk management, and financial outcomes.</p>
                <p><strong>By using Stocks4U, you confirm that you have read, understood, and accepted this Disclaimer.</strong></p>
              </section>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Disclaimer;
